<template>
  <div>
    <div class="sidenav-container">
      <!-- Sidenav for settings -->
      <div class="sidenav">
        <SettingsLayout active="ProductSettings"></SettingsLayout>
      </div>
      <!-- General settings content -->
      <div
        class="sidenave-main-content"
        style="padding:0 !important;margin-top:-6px;overflow-y:hidden"
      >
        <!-- Validation for Product -->
        <b-row class="px-3 border-bottom">
          <b-col cols="12" class="px-0">
            <h2
              class="custom-page-title mb-2 mt-1 px-4"
              style="position:relative;bottom:4px;"
            >Product</h2>
          </b-col>
        </b-row>
        <div
          class="sidenav-view-block pb-4"
          style="padding-left:0 !important;padding-right:0 !important;height: calc(100vh - 92px)"
        >
          <b-tabs class="customer_view_tab no-flex-grow mb-5 mt-1 border-tab">
            <b-tab title="General" active class="p-3">
              <b-form @submit.prevent="onSubmit">
                <b-row class="pt-2">
                  <b-col>
                    <p class="text-muted fw-semi-bold">Duplicate Product Name</p>
                    <b-form-checkbox
                      plain
                      :true-value="1"
                      :false-value="0"
                      v-model.trim="field.allow_duplicate_pdt"
                      class="mt-2 mb-3"
                    >
                      Allow duplicate product names
                      <span class="text-muted d-block">
                        If you allow duplicate product names, all imports
                        involving products will use SKU as the primary field for
                        mapping.
                      </span>
                    </b-form-checkbox>
                    <div
                      class="duplicate_details pl-2 pt-3 pr-2 mb-3"
                      v-if="!field.pdt_sku"
                      style="width:100%;stretch-height:100%;border-right:0 !important;"
                    >
                      <h6 class="pl-4">
                        <i class="fa fa-exclamation-triangle" style="color:#ff4747;font-size:15px"></i>
                        Before you enable this option, make the SKU field active.
                      </h6>
                    </div>

                    <span
                      class="text-link btn-link cursor_pointer fw-semi-bold"
                      v-if="data=='non_sku'"
                    >
                      <router-link
                        class="text-decoration-none"
                        :to="{ name: 'Productsku', query: { page: 1, show: 10 } }"
                      >Show all products without SKU.</router-link>
                    </span>
                    <div class="duplicate_details pl-2 pt-3 pr-2" v-else-if="data == 'Duplicate'">
                      <p>
                        Show all
                        <router-link
                          class="text-decoration-none"
                          :to="{
                          name: 'Product',
                          query: { page: 1, show: 10, status: 8 },
                        }"
                        >Products,</router-link>
                        <router-link
                          class="text-decoration-none"
                          :to="{
                          name: 'AmcService',
                          query: { page: 1, show: 10, status: 4 },
                        }"
                        >Product bundles-</router-link>with duplicate names
                      </p>
                    </div>
                  </b-col>
                </b-row>
                <hr align="left" />
                <b-row>
                  <b-col>
                    <p class="text-muted fw-semi-bold">Select the fields to display</p>
                    <b-form-checkbox
                      plain
                      v-model.trim="field.pdt_sku"
                      :true-value="1"
                      :false-value="0"
                    >Product SKU</b-form-checkbox>
                    <b-form-checkbox
                      plain
                      v-model.trim="field.pdt_img"
                      :true-value="1"
                      :false-value="0"
                      class="mt-2"
                    >Product Image</b-form-checkbox>
                    <b-form-checkbox
                      plain
                      :true-value="1"
                      :false-value="0"
                      v-model.trim="field.pdt_hsn_sac"
                      class="mt-2"
                    >Product HSN/SAC</b-form-checkbox>
                    <b-form-checkbox
                      :true-value="1"
                      :false-value="0"
                      plain
                      v-if="org_details.gst_type == 1"
                      v-model.trim="field.is_digital_service"
                      class="mt-2"
                    >
                      Track sale of digital services to overseas customers
                      <small
                        v-if="field.is_digital_service == 1"
                        class="text-muted d-block"
                      >
                        If you disable this option, any digital service created
                        by you will be considered as a service.
                      </small>
                      <small v-else class="text-muted d-block">
                        Enabling this option will let you record and track export
                        of digital services to individuals.
                      </small>
                    </b-form-checkbox>
                  </b-col>
                </b-row>
                <hr align="left" />
                <b-row>
                  <b-col>
                    <p class="text-muted fw-semi-bold">Product Bundle</p>
                    <b-form-checkbox
                      plain
                      :true-value="1"
                      :false-value="0"
                      v-model.trim="field.allow_service_only_bundle"
                      class="mt-2 mb-3"
                    >Allow to create product bundle with only services</b-form-checkbox>
                  </b-col>
                </b-row>

                <hr align="left" />

                <!--  price list module option -->
                <b-row>
                  <b-col cols="12" class="mt-1">
                    <p class="text-muted fw-semi-bold">Price List</p>
                    <b-form-group label label-for="sales_date">
                      <b-form-checkbox
                        :true-value="1"
                        :false-value="0"
                        plain
                        v-model.trim="field.is_price_list_enabled"
                        class="mt-2"
                      >Enable Price Lists</b-form-checkbox>
                      <b-form-checkbox
                        v-if="field.is_price_list_enabled == 1"
                        :true-value="1"
                        :false-value="0"
                        plain
                        v-model.trim="field.is_item_level_price_list_enabled"
                        class="mt-2"
                      >Apply price list on each product in a transaction</b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
                <div class="footer sidenav-footer" style="box-shadow:0 -4px 5px -3px #ccc;">
                  <div class="form-action" style="background:none !important;">
                    <b-button
                      type="submit"
                      size="sm"
                      variant="primary"
                      class="btn-rounded mr-3"
                      :disabled="submitted"
                      @click="general_settings=true"
                    >
                      <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Save
                    </b-button>
                  </div>
                </div>
              </b-form>
            </b-tab>
            <b-tab title="Field Customization" class="p-0 pt-2" @click="fetchCustomList()">
              <CustomFieldSettings
                v-on:handledelete="handledelete"
                v-on:onSubmit="customsubmit"
                custom_prefix="product_"
                :custom_field="custom_field"
                :max_count="max_count"
                :used_count="used_count"
                v-on:ConfigureSubmit="configureSubmit"
                :stg_menu="stg_menu"
              />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomFieldSettings from "@/components/Form/Settings/CustomField";
import SettingsLayout from "@/components/Layout/SettingsLayout";
import { mapState, mapGetters } from "vuex";
import vSelect from "vue-select";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling formatDate
import DatePicker from "vue2-datepicker"; // vue datepicker
export default {
  mixins: [notificationMixin, formatDate], // call the glbal mixin fucntion
  components: {
    SettingsLayout,
    DatePicker,
    CustomFieldSettings,
    vSelect
  },
  data() {
    return {
      data: "",
      index_value: "",
      inventory_date: "",
      error_show: false, // to show the error message
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
      submitted: false,
      allow_duplicate_pdt: "",
      is_digital_service: "",
      pdt_sku: "",
      pdt_img: "",
      pdt_hsn_sac: "",
      pdt_dimension_unit: "",
      dimensions: [
        {
          id: 1,
          text: "in"
        },
        {
          id: 2,
          text: "cm"
        }
      ],
      weights: [
        {
          id: 1,
          text: "lb"
        },
        {
          id: 2,
          text: "kg"
        }
      ],
      pdt_wgt_unit: "",
      update_id: "",
      general_settings: false,
      stg_menu: "Product",
      remaining_fields: ""
    };
  },
  methods: {
    fetchCustomList() {
      this.$store.dispatch("settings/fetchCustomList", { stg_menu: "Product" });
    },
    configureSubmit(ev) {
      var data = JSON.stringify({
        id: ev.id,
        stg_menu: "Product",
        app_id: process.env.VUE_APP_APP_ID,
        permissions: ev.permissions
      });
      this.$store
        .dispatch("settings/configureAccessUpdate", data)
        .then(response => {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.status_message,
            type: this.code == 200 ? "success" : "danger",
            showCloseButton: true
          });
          if (response.status == 200) {
            this.fetchCustomList();
            this.$store.state.permission.pdt_settings_details.custom_field =
              response.data.custom_field;
          }
        });
    },
    //  change the due date based on the payment in the customer master data and selected invoice date
    selectDate(val) {
      this.field.inventory_date =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
    },

    removeRow(index) {
      if (this.custom_field.length > 1) {
        this.custom_field.splice(index, 1);
      }
    },

    handledelete(ev) {
      var data = JSON.stringify({
        id: ev.index_value,
        stg_menu: "Product",
        table_name: "cbs_pdt_tbl_mas_usr_main"
      });
      this.$store.dispatch("settings/postdelete", data).then(() => {
        this.fetchCustomList();
        this.$router.push({
          name: this.$route.name,
          query: {
            update:
              this.$route.query.update || this.$route.query.update == true
                ? false
                : true
          }
        });
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: this.message,
          type: this.code == 200 ? "success" : "danger",

          showCloseButton: true
        });
      });
    },
    async customsubmit(ev) {
      if (ev.custom_field == 1) {
        //this.field.index = ev.index;
        //this.field.custom = true;
        this.remaining_fields = ev.remaining_fields;
        this.field.field = ev.custom_data;
        this.update_id = ev.update_id;
        this.general_settings = false;
        //this.field.page = ev.page;
        await this.settingsdata();
      }
    },
    settingsdata() {
      if (this.general_settings) {
        var data = {
          field: this.field,
          stg_menu: "Product",
          table_name: "cbs_pdt_tbl_mas_usr_main"
        };
        this.$store.dispatch("settings/invoice", data).then(result => {
          if (result.status == 201) {
            this.data = result.data.data;

            //  code for notificatin display
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: result.data.status,
              type: "danger",
              showCloseButton: true
            });
            return;
          }
          this.page = "";
          this.$router.push({
            name: this.$route.name,
            query: {
              update:
                this.$route.query.update || this.$route.query.update == true
                  ? false
                  : true
            }
          });
          //  code for notificatin display
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: result.data.status,
            type: "success",
            showCloseButton: true
          });
        });
      } else {
        var data = {
          field: this.field.field,
          remaining_fields: this.remaining_fields,
          stg_menu: "Product",
          table_name: "cbs_pdt_tbl_mas_usr_main"
          // custom_field: this.custom_field
        };

        if (this.page == "create") {
          this.$store
            .dispatch("settings/customfieldcreate", data)
            .then(result => {
              if (result.status == 201) {
                //  code for notificatin display
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                  message: result.data.status,
                  type: "danger",
                  showCloseButton: true
                });
                return;
              }
              if (result.status == 200) {
                this.$store.state.permission.pdt_settings_details.custom_field =
                  result.data.custom_field;
                this.fetchCustomList();
              }
              this.page = "";
              this.$router.push({
                name: this.$route.name,
                query: {
                  update:
                    this.$route.query.update || this.$route.query.update == true
                      ? false
                      : true
                }
              });
              //  code for notificatin display
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: this.status_message,
                type: "success",
                showCloseButton: true
              });
            });
        }
        if (this.page == "update") {
          this.$store
            .dispatch("settings/customfieldupdate", {
              data: data,
              remaining_fields: this.remaining_fields,
              id: this.update_id
            })
            .then(result => {
              if (result.status == 201) {
                //  code for notificatin display
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                  message: result.data.status,
                  type: "danger",
                  showCloseButton: true
                });
                return;
              }
              if (result.status == 200) {
                this.$store.state.permission.pdt_settings_details.custom_field =
                  result.data.custom_field;
                this.fetchCustomList();
              }
              this.page = "";
              this.$router.push({
                name: this.$route.name,
                query: {
                  update:
                    this.$route.query.update || this.$route.query.update == true
                      ? false
                      : true
                }
              });
              //  code for notificatin display
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: this.status_message,
                type: "success",
                showCloseButton: true
              });
            });
        }
      }
    },
    async onSubmit() {
      // await this.removeRoute();
      this.$validator.validateAll().then(result => {
        if (result) {
          //this.field.custom = false;
          this.submitted = true;
          this.settingsdata();
          setTimeout(() => {
            this.submitted = false;
          }, 3000);
        } else {
          this.error_show = true; // validate the form if fail
        }
      });
      return false;
    }
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    store
      .dispatch("settings/fetchCustomList", {
        stg_menu: "Product"
      })
      .then(() => {
        next();
      });
    store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Product",
        stg_name: "pdt_settings_details"
      })
      .then(() => {
        next();
      });
  },

  beforeRouteEnter(to, from, next) {
    store
      .dispatch("settings/fetchCustomList", {
        stg_menu: "Product"
      })
      .then(() => {
        next();
      });
    store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Product",
        stg_name: "pdt_settings_details"
      })
      .then(() => {
        next();
      });
  },
  beforeRouteLeave(to, from, next) {
    // ...
    store
      .dispatch("settings/fetchinvoicesettings", {
        stg_menu: "Product",
        stg_name: "pdt_settings_details"
      })
      .then(() => {
        next();
      });
  },
  created() {
    this.page = "";
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    page: {
      get() {
        return this.$store.state.settings.page;
      },
      set(val) {
        this.$store.state.settings.page = val;
      }
    },
    ...mapState({
      field: state => state.settings.list["Product"] || { custom_field: {} },
      list: state => state.settings.list,
      custom_field: state => state.settings.custom_list,
      message: state => state.settings.delete_message,
      max_count: state => state.settings.max_count,
      used_count: state => state.settings.used_count,
      code: state => state.settings.code,
      status_message: state => state.settings.status_message
    }),
    ...mapGetters(["org_details"]),
    price_list: {
      get() {
        return this.$store.state.permission.price_list;
      },
      set(val) {
        this.$store.state.permission.price_list = val;
      }
    },
    pdt_settings_details: {
      get() {
        return this.$store.state.permission.pdt_settings_details;
      },
      set(val) {
        this.$store.state.permission.pdt_settings_details = val;
      }
    }
  }
};
</script>
<style scoped>
.duplicate_details {
  background: #fff4e7;
  padding: 7px 7px;
  max-width: 50%;
}
</style>
